import React from "react";

function helpSectionDetailView() {
    return (
        <div className="wrapper">
            <div className="hero-banner">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-8 col-md-12">
                            <div className="hero-banner-content text-center">
                                <h2>How can we help?</h2>
                                <p className="ps-0">Search our knowledge base or submit a ticket.</p>
                                <div className="">
                                    <input className="form-control h_50 w-100" type="text" placeholder="Search articles" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="explore-events p-80">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12 col-md-12">
                            <div className="main-title checkout-title">
                                <h3>I am an Organiser</h3>
                            </div>
                        </div>
                        <div className="col-lg-8 col-md-12">
                            <div className="main-card mt-5">
                                <a href="help_article_detail_view.html" className="help-item-link">How is your service charge calculated?</a>
                                <a href="help_article_detail_view.html" className="help-item-link">Where is my event's name being used?</a>
                                <a href="help_article_detail_view.html" className="help-item-link">Where can I find the information entered by my attendees?</a>
                                <a href="help_article_detail_view.html" className="help-item-link">How do I build my own attendee details form?</a>
                                <a href="help_article_detail_view.html" className="help-item-link">What is the 'Refer a friend' feature?</a>
                                <a href="help_article_detail_view.html" className="help-item-link">Can I see a list of all attendee’s emails?</a>
                                <a href="help_article_detail_view.html" className="help-item-link">How can I track my ticket sales?</a>
                                <a href="help_article_detail_view.html" className="help-item-link">Can I download the recordings of my event?</a>
                                <a href="help_article_detail_view.html" className="help-item-link">How can I refund my attendees?</a>
                                <a href="help_article_detail_view.html" className="help-item-link">Image Dimensions in Barren </a>
                                <a href="help_article_detail_view.html" className="help-item-link">How do I get paid?</a>
                                <a href="help_article_detail_view.html" className="help-item-link">How do I use your platform?</a>
                                <a href="help_article_detail_view.html" className="help-item-link">Can we make tickets free for a selected group of people?</a>
                                <a href="help_article_detail_view.html" className="help-item-link">How do I respond to a refund request from my attendee?</a>
                                <a href="help_article_detail_view.html" className="help-item-link">How does choosing an event banner help my event?</a>
                            </div>
                            <div className="help-pagination d-flex align-item-center justify-content-between">
                                <a href="#" className="help-pagination-link"><i className="fa-solid fa-circle-left me-2"></i>Previous</a>
                                <a href="#" className="help-pagination-link">Next<i className="fa-solid fa-circle-right ms-2"></i></a>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-12">
                            <div className="main-card mt-5">
                                <div className="bp-title">
                                    <h4>Popular Articles</h4>
                                </div>
                                <div className="help-faq-content">
                                    <a href="help_article_detail_view.html" className="help-faq-link">Where is my event's name being used?</a>
                                    <a href="help_article_detail_view.html" className="help-faq-link">How to build my own survey?</a>
                                    <a href="help_article_detail_view.html" className="help-faq-link">How can I refund my attendees?</a>
                                    <a href="help_article_detail_view.html" className="help-faq-link">How do I choose a suitable template for my event?I am hosting a large online event. What do you recommend?</a>
                                    <a href="help_article_detail_view.html" className="help-faq-link">I am hosting a large online event. What do you recommend?</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default helpSectionDetailView;